export default {
      id: "hotel-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#hotel",
      toString: function () {
        return this.url;
      }
    }